export function neverReached(_never: never): void {
    // empty
}

export default { neverReached };
